import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  checkCircleIcon: {
    color: '#4DC37D',
    verticalAlign: 'text-top',
    fontSize: 'larger',
    marginRight: '5px'
  },
  uploadText: {
    fontSize: '14px',
    color: '#545455',
    marginRight: '22px'
  }
}))

export { useStyles }
